import { PhoneLockedSharp } from "@mui/icons-material";
import * as Yup from "yup";

import { variables } from "../Variables";

const { required, IsNum, numReg } = variables;

export const ModalValidationBqankTransfer = Yup.object({
  bank_name: Yup.string().required(required),
  wallet_id: Yup.string().required(required),
  account_number: Yup.string().matches(numReg, IsNum).required(required),
  amount: Yup.number()
    .positive("Must be more than 0")
    .integer("Must be more than 0")
    .test(
      "len",
      "Must be less then 10,000,000",
      (val) => !val || (val && val.toString().length < 9)
    )
    .required("This field is required"),
  transfer_remark: Yup.string().required(required),
  transaction_password: Yup.string().required(required),
});
export const ModalValidationPayAttitude = Yup.object({
  wallet_id: Yup.string().required(required),
  phone_number: Yup.number().required(IsNum),
  amount: Yup.number()
    .positive("Must be more than 0")
    .integer("Must be more than 0")
    .required("This field is required"),
});
export const ModalValidationViaCreditCard = Yup.object({
  wallet_id: Yup.string().required("This field is required"),
  amount: Yup.number()
    .positive("Must be more than 0")
    .integer("Must be more than 0")
    .required("This field is required"),
  name_on_card: Yup.string()
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .required("This field is required"),
  card_number: Yup.number()
    .test(
      "len",
      "Must be exactly 16 characters",
      (val) => !val || (val && val.toString().length === 16)
    )
    .required("This field is required"),
  // expiration: Yup.string().required(required),
  cvv: Yup.number()
    .test(
      "len",
      "Must be exactly 4 characters",
      (val) => !val || (val && val.toString().length < 5)
    )
    .required("This field is required"),
  password: Yup.string().required(required),
});
export const ModalValidationUSSD = Yup.object({
  wallet_id: Yup.string().required(required),
  bank_name: Yup.string().required(required),
  amount: Yup.number()
    .positive("Must be more than 0")
    .integer("Must be more than 0")
    .required("This field is required"),
  phone_number: Yup.number().required(IsNum),
});

//Validation Schema for {Betting} SideModals
export const BetValidations = Yup.object({
  amount: Yup.number().required("Amount is Required").positive("Amount Must be more than 0"),
  wallet_id: Yup.string().required("Please Choose Wallet For Payment"),
  service_provider: Yup.string().required("Please Choose Service Provider"),
  package: Yup.string().required("This Field is Required"),
  customer_id: Yup.string().required("This Field is Required"),
  pass: Yup.string().required("Password is Required"),
  //  .max(12,"Password cannot be greater then 12 characters"),
});

//Validation Schema for {Utillity Bills} SideModals
export const FormValidations = Yup.object({
  amount: Yup.number().required("Amount is Required").positive("Amount Must be more than 0"),
  wallet_id: Yup.string().required("Please Choose Wallet For Payment"),
  service_provider: Yup.string().required("This Field is Required"),
  package: Yup.string().required("This Field is Required"),
  customer_id: Yup.string().required("This Field is Required"),
  pass: Yup.string().required("Password is Required")
  //  .max(12,"Password cannot be greater then 12 characters"),
});

//Validation Schema for {Utillity Bills} SideModals
export const BillsValidations = Yup.object({
  amount: Yup.number().required("Amount is Required").positive("Amount Must be more than 0"),
  wallet_id: Yup.string().required("Please Choose Wallet For Payment"),
  service_provider: Yup.string().required("This Field is Required"),
  package: Yup.string().required("This Field is Required"),
  customer_id: Yup.string().required("This Field is Required"),
  pass: Yup.string().required("Password is Required"),
  //  .max(12,"Password cannot be greater then 12 characters"),
});

//Validation Schema for Cable SideModal
export const CableValidations = Yup.object({
  amount: Yup.number().required("Amount is Required").positive("Amount Must be more than 0"),
  wallet_id: Yup.string().required("Please Choose Wallet For Payment"),
  service_provider: Yup.string().required("This Field is Required"),
  package: Yup.string().required("This Field is Required"),
  // customer_id: Yup.string().required("This Field is Required"),
  pass: Yup.string().required("Password is Required"),
  decoder_number: Yup.string().required("This Field is Required"),
  // meter_number: Yup.number().required("Amount is Required"),
  //  .max(12,"Password cannot be greater then 12 characters"),
});

//Validation Schema for Airtime SideModals
export const AirtimeValidations = Yup.object({
  amount: Yup.number().required("Amount is Required").positive("Amount Must be more than 0"),
  wallet_id: Yup.string().required("Please Choose Wallet For Payment"),
  network_provider: Yup.string().required("This Field is Required"),
  phone_number: Yup.number().required("Phone Number is Required"),
  pass: Yup.string().required("Password is Required"),
});

//Validation Schema for Data SideModals
export const DataValidations = Yup.object({
  network_provider: Yup.string().required("This Field is Required"),
  wallet_id: Yup.string().required("Please Choose Wallet For Payment"),
  amount: Yup.number().required("Amount is Required").positive("Amount Must be more than 0"),
  packages: Yup.string().required("This Field is Required"),
  phone_number: Yup.string().required("This Field is Required"),
  pass: Yup.string().required("Password is Required"),
});

export const phoneNumberValidation = Yup.object({
  phone_number: Yup.string().matches(numReg, IsNum).required(required),
});
